import { Sparkles } from "lucide-react";
import { IMG } from "@/lib/site";
import Chapter from "@/components/cinema/Chapter";
import AudienceTabs from "@/components/AudienceTabs";
import { Reveal, LineReveal } from "@/components/cinema/Reveal";

export default function AudiencesChapter() {
  return (
    <Chapter img={IMG.packback} overlay="dark" testId="audiences">
      <div className="grid md:grid-cols-12 gap-10 mb-12 items-end">
        <div className="md:col-span-7">
          <Reveal y={16}><div className="eyebrow eyebrow-light mb-5">Who we serve</div></Reveal>
          <LineReveal
            className="display-chunky text-4xl md:text-6xl text-white leading-[0.92]"
            lines={["A tailored response", "for every role", "on the project."]}
          />
        </div>
        <Reveal delay={0.35} className="md:col-span-5 text-white/75 leading-relaxed">
          <Sparkles className="w-5 h-5 text-[hsl(var(--gaza-blue-bright))] inline mr-2 mb-1" />
          Tap a role below to see exactly how we work with you.
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <div className="bg-white/95 backdrop-blur-xl text-[hsl(var(--gaza-teal))] p-7 md:p-14 shadow-[0_60px_140px_-50px_rgba(0,0,0,0.9)]">
          <AudienceTabs />
        </div>
      </Reveal>
    </Chapter>
  );
}
